import styled from 'styled-components'
import { useAppSelector } from '../../store/hooks'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { SvgBrokenCable } from '../SvgImports'
import { getErrorState } from '../../store/sessionDataSlice'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--tds-blue-800);
  color: var(--tds-white);
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  user-select: none;

  // TODO: Revisit and try to eliminate.
  z-index: 1000;

  svg {
    width: 100px;
  }
  .broken-cable-wrapper svg {
    fill: rgba(255, 255, 255, 0.2);
    margin-bottom: 10vh;
  }
  p {
    max-width: 500px;
  }
`

export function ErrorLayer() {
  const hasError = useAppSelector(getErrorState)
  const t2 = useTextsV2()

  return (
    <Overlay>
      <div className="broken-cable-wrapper">
        <SvgBrokenCable />
      </div>
      <h2>{t2(TextId.HEADER_ERROR_OCCURD)}</h2>
      <p>{hasError.friendlyErrorMessage || 'An unknown error occurred.'}</p>
    </Overlay>
  )
}
